import { ComponentElem } from "@components/interfaces";
import Input from "@root/components/ui/inputs/SimpleInput";
import PopupBase from "./PopupBase";
import PatternSamples from "@root/ts/PatternSamples";
import FormTools from "@root/ts/FormTools";
import ApiProxy from "@root/ts/ApiProxy";
import EZAlert from "./EZAlert";
import { Common } from "../common/CommonTypes";
import schema from "@schema/common/login-invite.json";

export default class LoginInvite extends PopupBase
{
  static instance: LoginInvite;

  autoClose_cover: boolean = false;

  constructor(elem: ComponentElem)
  {
    super(elem);

    LoginInvite.instance = this;

    let self = this;

    let $input = this.$root.find("input"),
      inputElem: HTMLInputElement = $input[0],
      input: Input = (this.$root.find('[component="simple-input"]')[0] as ComponentElem)._component;

    $input.on("change input", ()=>
    {
      this._update();
    });

    inputElem.value = "";

    this.$root.find(".btn-send").on("click", (event:Event)=>
    {
      event.preventDefault();
      
      let value = inputElem.value,
        isOk = PatternSamples["simple"].test(value);

      

      if(isOk)
      {
        EZAlert.pending(true);
        ApiProxy.callApi("login-invite", {invite_code: value}, {schema: schema, exampleIndex: 0}).then((response)=>
        {
          EZAlert.pending(false);
          this.$root.attr("state", "complete");
        }).catch((error: Common.SendFormError)=>
        {
            EZAlert.pending(false);
            input.toggleState("error", error.message as string);
        });
      }
      else
      {
        let message = value.length === 0 ? "此欄位必填" : "資料格式錯誤";
        input.toggleState("error", message);
      }
      

    });
  }

  private _update()
  {
    let input = this.$root.find("input")[0] as HTMLInputElement;
    this.$root.attr("with-invite-code", input.value? "true": "false");    
  }

  setInviteCode(inviteCode: string)
  {
    let input = this.$root.find("input")[0] as HTMLInputElement;
    input.value = inviteCode;

    this._update();
  }
}